
     $('.slideimage').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 3000,
      adaptiveHeight: true,
       prevArrow: `<div class="arrow arrow_left"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22" fill="none"><path d="M12 1L2 11L12 21" stroke="black" stroke-width="1.5"/></svg></div>`,
      nextArrow: `<div class="arrow arrow_right"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22" fill="none"><path d="M1 1L11 11L1 21" stroke="black" stroke-width="1.5"/></svg></div>`,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 769,
          settings: {
            arrows: true,
             dots: true,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
             dots: true,
            slidesToShow: 1
          }
        }
      ]
    });
